export const CITY_DISTRICTS = {
  // Greater China
  'Hong Kong':    ['中西區','灣仔','東區','南區','尖沙咀','旺角','油麻地','深水埗','九龍城','黃大仙','觀塘','荃灣','葵青','屯門','元朗','北區','大埔','沙田','西貢','東涌','坪洲','長洲','梅窩','南丫島','愉景灣','迪士尼'],
  'Macau':        ['氹仔','路氹','澳門半島','新口岸','黑沙環','石排灣','青洲'],
  'Taipei':       ['信義區','大安區','西門町','士林','淡水','九份','北投','中山','萬華','松山','大同','文山','新店區','內湖區','八里區','中和區','汐止區'],
  'Kaohsiung':    ['駁二藝術特區','西子灣','六合夜市','瑞豐夜市','旗津','義大世界','美麗島','鹽埕','左營','鼓山','鳳山區','燕巢區'],
  'Taichung':     ['逢甲夜市','一中街','彩虹眷村','高美濕地','東海大學','草悟道','大坑','審計新村','后里','清水','大甲區','外埔區'],
  'Tainan':       ['安平','赤崎樓','花園夜市','孔廟','神農街','國華街','林百貨','奇美博物館','仁德','永康'],
  'Yilan':        ['礁溪','羅東','頭城','蘇澳','冬山','五結','三星','宜蘭市','南澳鄉'],
  'Hualien':      ['花蓮市','太魯閣','七星潭','鯉魚潭','瑞穗','玉里','光復','豐濱鄉','秀林鄉','富里鄉','壽豐鄉','新城鄉','卓溪鄉'],
  'Kenting':      ['墾丁大街','白沙灣','貓鼻頭','鵝鑾鼻','南灣','龍磐公園','船帆石','恆春鎮','滿州鄉','車城鄉'],
  'Jiufen':       ['九份老街','金瓜石','十分','平溪','猴硐'],
  'New Taipei':   ['烏來溫泉','三峽老街','鶯歌陶瓷老街','野柳地質公園','深坑老街','板橋車站','烏來區'],
  'Taoyuan':      ['大溪老街','慈湖','拉拉山','東眼山','中壢夜市','龜山區','復興區','桃園區'],
  'Hsinchu County': ['內灣老街','北埔老街','關西六福村','尖石鄉','峨眉湖'],
  'Miaoli County':  ['南庄老街','三義木雕街','大湖草莓園','通霄海水浴場','客家圓樓','造橋鄉','南庄鄉','後龍鎮'],
  'Chiayi County':  ['阿里山','奮起湖老街','布袋港','故宮南院','梅山瑞里','六腳鄉','太保市','梅山鄉','朴子市'],
  'Yunlin County':  ['劍湖山世界','北港朝天宮','古坑咖啡大街','虎尾糖廠','西螺大橋','西螺鎮','虎尾鎮','北港鎮'],
  'Penghu County':  ['澎湖跨海大橋','七美嶼','吉貝嶼','馬公老街','奎壁山','望安島','西嶼','風櫃'],
  'Kinmen County':  ['金城(後浦)','水頭聚落','金湖','金沙','古寧頭','烈嶼'],
  'Lienchiang County': ['南竿','北竿','芹壁村','莒光','東引'],
  'Changhua County': ['鹿港老街','八卦山大佛','田尾','溪湖','員林','二林'],
  'Nantou County':  ['日月潭','清境農場','合歡山','溪頭','埔里','集集'],
  'Taitung County': ['台東市區','池上','鹿野高台','三仙台','知本溫泉','綠島','蘭嶼'],
  'Beijing':      ['天安門','故宮','三里屯','王府井','頤和園','南鑼鼓巷','798藝術區','什剎海','前門','西單','豐臺區','海淀區','懷柔區','朝陽區','門頭溝區','昌平區','大興區','通州區','延慶區','房山區','石景山區'],
  'Shanghai':     ['外灘','南京路','豫園','新天地','靜安寺','田子坊','虹橋','浦東','徐匯','長寧','松江區','浦東新區','寶山區','嘉定區','青浦區','奉賢區'],
  'Guangzhou':    ['天河','越秀','荔灣','海珠','番禺','花都','北京路','珠江新城','南沙區','從化區','黃埔區','白雲區','增城區'],
  'Shenzhen':     ['南山','福田','羅湖','寶安','龍崗','鹽田','東門','大鵬','光明區','龍華區','坪山區'],
  'Chengdu':      ['錦里','寬窄巷子','天府廣場','春熙路','武侯祠','都江堰','青城山','九寨溝','武侯區','雙流區','溫江區','成華區','郫都區','金牛區','青羊區','新都區'],
  'Chongqing':    ['解放碑','磁器口','南岸','渝中','洪崖洞','觀音橋','沙坪壩','北碚','武隆','兩江新區','永川區','九龍坡區','奉節縣','重慶高新區','合川區','江津區'],
  "Xi'an":        ['鐘鼓樓','兵馬俑','大雁塔','回民街','曲江','城牆','半坡','未央區','灞橋區','雁塔區','臨潼區','長安區'],
  'Hangzhou':     ['西湖','靈隱寺','河坊街','西溪濕地','千島湖','烏鎮','南潯','龍井','蕭山區','濱江區','拱墅區','錢塘區','臨安區','餘杭區','臨平區','富陽區','桐廬縣','上城區'],
  'Xiamen':       ['鼓浪嶼','中山路','曾厝垵','集美','南普陀','廈門大學','湖裡區','思明區','海滄區','同安區','翔安區'],
  'Guilin':       ['陽朔','漓江','象山','七星公園','龍脊梯田','蘆笛岩','正陽路','龍勝縣','雁山區','靈川縣'],
  'Sanya':        ['亞龍灣','三亞灣','大東海','天涯海角','蜈支洲島','鹿回頭','海口','崖州區','天涯區','海棠區','吉陽區'],
  'Zhangjiajie':  ['天門山','武陵源','金鞭溪','袁家界','寶峰湖','慈利縣'],
  'Kunming':      ['石林','大觀樓','翠湖','滇池','西山','碧雞坊','呈貢區','晉寧區','宜良縣'],
  'Qingdao':      ['棧橋','五四廣場','八大關','嶗山','台東','中山路','奧帆中心','黃島區','李滄區','城陽區','即墨區'],
  'Suzhou':       ['拙政園','平江路','山塘街','寒山寺','金雞湖','周莊','吳江區','蘇州工業園區','吳中區'],
  'Zhuhai':       ['情侶路','長隆海洋王國','珠海漁女','橫琴','御溫泉','外伶仃島','斗門區','香洲區'],
  'Foshan':       ['祖廟','嶺南天地','順德','南風古灶','西樵山','南海區','三水區'],
  // Japan
  'Tokyo':        ['澀谷','新宿','淺草','銀座','原宿','六本木','秋葉原','池袋','上野','築地','台場','赤坂','惠比壽','代官山','中目黑','八王子市','中野区','江東区','江戸川区','世田谷区','大田区','品川区','杉並区'],
  'Osaka':        ['道頓堀','心齋橋','難波','梅田','天王寺','新世界','北堀江','大阪城','福島','北區','此花区','吹田市','摂津市','堺市','箕面市'],
  'Kyoto':        ['祇園','嵐山','伏見稻荷','金閣寺','四條河原町','清水坂','錦市場','嵯峨野','哲學之道'],
  'Fukuoka':      ['博多','中洲','天神','大濠公園','太宰府','糸島','門司港','小倉','北九州市','福津市'],
  'Sapporo':      ['大通公園','薄野','圓山','定山溪','小樽','富良野','中富良野町','江別市'],
  'Nagoya':       ['榮','名古屋城','大須','矢場町','伏見','栄生','熱田神宮','長久手市'],
  'Okinawa':      ['那霸','石垣島','宮古島','今歸仁','沖繩市','北谷','本部','名護','南城','豐見城','讀谷','恩納','北中城','宇流麻','竹富','宜野灣','浦添','糸滿','國頭','東村','嘉手納','西原','渡嘉敷','中城','座間味','金武','伊江'],
  'Hiroshima':    ['和平紀念公園','宮島','廣島城','本通','紙屋町','袋町','尾道','岩国市','東広島市','廿日市市'],
  'Nara':         ['奈良公園','東大寺','春日大社','興福寺','吉城園','元興寺','柳生','山添村'],
  'Kobe':         ['北野異人館','南京町','三宮','元町','六甲山','有馬溫泉','舞子'],
  'Kanazawa':     ['兼六園','長町武家屋敷','東茶屋街','近江町市場','金澤城公園'],
  'Yokohama':     ['港未來','山下公園','橫濱中華街','紅磚倉庫','橫濱站','元町','三溪園','八景島'],
  'Karuizawa':    ['輕井澤站','中輕井澤','雲場池','白絲瀑布','王子購物廣場'],
  'Kurashiki':    ['倉敷美觀地區','大原美術館','倉敷站','兒島牛仔褲街','鷲羽山'],
  'Santiago de Compostela': ['聖地牙哥大教堂','奧布拉多伊羅廣場','老城區','阿拉梅達公園','食品市場','加利西亞文化城'],
  'Tilburg':      ['市中心','紡織博物館','德蓬特美術館','鐵道區','莫倫堡公園'],
  'Curitiba':     ['植物園','鐵絲網歌劇院','奧德姆廣場','尼邁耶博物館','巴里古伊公園','十一月十五日街'],
  'Palenque':     ['帕倫克遺址','阿瓜阿祖爾瀑布','米索哈瀑布','帕倫克市中心'],
  'Nemuro':       ['納沙布岬','根室站','花咲港','春國岱'],
  'Shijiazhuang': ['正定古城','隆興寺','西柏坡','趙州橋','蒼岩山','河北博物院','石家莊站'],
  'Banff':        ['班夫大道','班夫上溫泉','硫磺山','弓河瀑布','明尼旺卡湖','露易絲湖','夢蓮湖'],
  'Liverpool':    ['皇家阿爾伯特碼頭','碼頭大樓','利物浦一號','馬修街','安菲爾德','利物浦大教堂','中國城'],
  'Kumamoto':     ['熊本城','上通町','水前寺公園','黑川溫泉','阿蘇山','阿蘇市','小国町','高森町'],
  'Kagoshima':    ['天文館','櫻島','仙巖園','鹿兒島中央車站','霧島'],
  'Nagasaki':     ['出島','眼鏡橋','中華街','稻佐山','平和公園','豪斯登堡','佐世保市'],
  'Sendai':       ['青葉城址','國分町','仙台站','松島','秋保溫泉','定禪寺通','利府町'],
  'Nikko':        ['東照宮','中禪寺湖','華嚴瀑布','日光江戶村','鬼怒川溫泉'],
  'Hakone':       ['大涌谷','箱根神社','強羅','仙石原'],
  'Hokkaido':     ['小樽','美瑛','富良野','洞爺湖','二世谷','旭川動物園','旭川市','函館市','倶知安町','壮瞥町','上富良野町'],
  // Korea
  'Seoul':        ['明洞','弘大','江南','東大門','仁寺洞','梨泰院','北村','益善洞','聖水洞','光化門','慶福宮','樂天世界'],
  'Busan':        ['海雲台','廣安里','南浦洞','甘川文化村','影島','機張','松島','西面'],
  'Jeju':         ['濟州市','西歸浦','城山日出峰','漢拏山','牛島','萬丈窟','O\'Sulloc茶園','翰林'],
  'Incheon':      ['仁川中華街','松島國際都市','月尾島','富平','江華島','仁川大公園','仁川國際機場'],
  'Gyeongju':     ['佛國寺','石窟庵','大陵苑','東宮與月池','良洞民俗村','慶州歷史遺跡區'],
  'Daegu':        ['西門市場','東城路','八公山','金光石路','桃城洞'],
  // Southeast Asia
  'Singapore':    ['牛車水','小印度','克拉碼頭','烏節路','聖淘沙','濱海灣','武吉士','樟宜','植物園'],
  'Bangkok':      ['暹羅','考山路','是隆','素坤逸','老城區','中國城','查圖查週末市場','阿索克'],
  'Chiang Mai':   ['古城區','尼曼路','夜市','素帖山','雙龍寺','清邁夜市'],
  'Phuket':       ['芭東','卡塔','卡隆','老城','奈漢','Rawai','攀牙灣','卡馬拉'],
  'Chiang Rai':   ['白廟','藍廟','黑屋博物館','金三角'],
  'Krabi':        ['奧南海灘','雷利海灘','四島遊','甲米鎮'],
  'Pattaya':      ['芭達雅海灘','真理寺','格蘭島','芭達雅步行街'],
  'Bali':         ['庫塔','水明漾','烏布','努沙杜瓦','金巴蘭','水渡口','克羅波坎','坎古','登巴薩','德格拉朗'],
  'Jakarta':      ['科塔','甘榜查利亞','布洛克M','蘇迪曼','坦格朗','科莫多港','北雅加達'],
  'Yogyakarta':   ['婆羅浮屠','普蘭班南','馬里奧博羅街','日惹城堡','默拉皮火山'],
  'Surabaya':     ['蘇拉巴亞動物園','英雄紀念碑'],
  'Komodo':       ['科莫多國家公園','粉紅沙灘','巴達爾島','林卡島','納閩巴霍'],
  'Kuala Lumpur': ['武吉免登','KLCC','茨廠街','孟沙','班底谷','黑風洞','布城','蕉賴'],
  'Penang':       ['喬治市','峇都丁宜','亞依淡','直落峇賴','升旗山','峇都茅'],
  'Malacca':      ['雞場街','荷蘭紅屋','聖保羅山','馬六甲河畔'],
  'Ipoh':         ['舊街場','極樂洞','天空之鏡'],
  'Kota Kinabalu':['亞庇市中心','丹絨亞路海灘','神山','沙比島'],
  'Hanoi':        ['還劍湖','老城區','西湖','文廟','河內歌劇院','寧平'],
  'Ho Chi Minh City':['第一郡','第三郡','Thao Dien','濱城市場','戰爭博物館','湄公河'],
  'Da Nang':      ['美山聖地','會安','巴拿山','美溪沙灘','龍橋','五行山'],
  'Nha Trang':    ['芽莊海灘','婆那加占婆塔','珍珠島樂園','龍山寺'],
  'Phu Quoc':     ['富國島','陽東海灘','富國夜市','珍珠樂園'],
  'Manila':       ['因特拉穆羅斯','BGC','馬卡蒂','馬尼拉灣','羅哈斯大道','奎阿波'],
  'Cebu':         ['宿霧市','麥哲倫十字架','莫阿爾博阿','歐斯陸','麥克坦島'],
  'Siem Reap':    ['吳哥窟','吳哥城','塔普倫廟','女王宮','洞里薩湖','夜市'],
  'Colombo':      ['科倫坡堡','貝塔','科倫坡3區','甘地格漢','尼甘布','加勒'],
  'Maldives':     ['馬累','北馬累環礁','南馬累環礁','阿里環礁','拉環礁','巴環礁'],
  // South Asia
  'Mumbai':       ['南孟買','科拉巴','達拉維','班德拉','朱胡','波瓦拉','安德里'],
  'Delhi':        ['康諾特廣場','老德里','新德里','胡馬雍陵','勒第花園','卡洛爾巴'],
  'Goa':          ['巴拿吉','卡蘭古特','博加','阿夫蘭科','科爾瓦','帕納吉','老果阿'],
  'Jaipur':       ['琥珀堡','風之宮殿','城市宮殿','粉紅城'],
  'Agra':         ['泰姬瑪哈陵','阿格拉堡','法泰赫布爾西克里'],
  'Kathmandu':    ['杜巴廣場','帕坦','巴克塔普爾','泰美爾','帕蘇帕蒂納特','博達'],
  // Middle East
  'Dubai':        ['迪拜購物中心','棕櫚島','迪拜老城','朱美拉','迪拜碼頭','溪邊區','帆船酒店','迪拜未來博物館'],
  'Abu Dhabi':    ['謝赫扎耶德清真寺','亞斯島','科尼奇','薩迪亞特島','露瓦斯','阿布達比島'],
  'Doha':         ['伊斯蘭藝術博物館','珍珠島','老城','哈里發球場','科尼奇','卡塔拉'],
  'Istanbul':     ['蘇丹艾哈邁德','格拉達','博斯普魯斯','貝西克塔什','尼尚塔斯','卡德克伊','法提赫'],
  'Riyadh':       ['王國中心塔','迪拉廣場','利雅得老城'],
  'Jeddah':       ['吉達老城','紅海海濱步道','浮動清真寺','阿爾巴拉德區'],
  'Tel Aviv':     ['雅法古城','海灘區','羅斯柴爾德大道','卡梅爾市場','白城'],
  // Europe
  'Paris':        ['蒙馬特','瑪黑區','香榭大道','左岸','艾菲爾鐵塔','拉丁區','聖日耳曼','盧浮宮','楓丹白露'],
  'London':       ['西區','南岸','肖爾迪奇','諾丁山','格林威治','坎頓','科文特花園','切爾西','伊斯靈頓'],
  'Rome':         ['鬥獸場','梵蒂岡','特雷維噴泉','納沃納廣場','西班牙階梯','博爾蓋塞','特拉斯提弗列'],
  'Milan':        ['時尚四邊形','大教堂','布雷拉','Navigli','維托里奧廣場'],
  'Florence':     ['舊橋','聖母百花大教堂','米開朗基羅廣場','奧特拉諾'],
  'Venice':       ['聖馬可廣場','麗都島','布拉諾','穆拉諾','多爾索杜羅','卡納雷吉奧'],
  'Barcelona':    ['哥德區','聖家堂','格拉西亞大道','巴塞羅內塔','格拉西亞區','蒙特惠奇'],
  'Madrid':       ['普拉多博物館','索菲亞王后','格蘭大道','馬約爾廣場','雷提羅公園','馬拉薩納'],
  'Amsterdam':    ['約旦','東區','勒澤普廣場','博物館廣場','阿姆斯特爾','紅燈區','弗雷德里克斯廣場'],
  'Berlin':       ['米特','普倫茨勞爾貝格','腓特烈斯海因','夏洛滕堡','波茨坦廣場','十字山'],
  'Munich':       ['馬林廣場','英式花園','奧林匹克公園','達豪','施瓦賓','新天鵝堡'],
  'Prague':       ['老城廣場','查理大橋','城堡區','小城區','維謝赫拉德','維諾赫拉迪'],
  'Vienna':       ['美泉宮','瑪利亞廣場','普拉特','納許馬爾克特','格林津'],
  'Budapest':     ['布達城堡','漁夫堡','英雄廣場','安德拉什大街','魯達什溫泉','瑪格麗特島'],
  'Lisbon':       ['阿爾法瑪','貝倫','希亞多','拜薩','格拉薩','莫里斯卡','辛特拉'],
  'Athens':       ['衛城','古市集','憲法廣場','普拉卡','科洛納基','莫納斯提拉奇','維爾維','大都會'],
  'Santorini':    ['菲拉','伊亞','奧亞','佩里薩','卡馬里','伊莫洛維格利'],
  'Edinburgh':    ['皇家英里','新城','舊城','萊斯','卡爾頓山','迪恩村','斯托克布里奇'],
  'Copenhagen':   ['新港','腓特烈斯堡','諾雷布羅','克里斯蒂安港','菲埃德比','蒂沃利'],
  'Stockholm':    ['老城','Södermalm','Östermalm','Djurgården','林地公墓'],
  'Oslo':         ['阿克爾碼頭','格林爾洛卡','格拉夫森','Majorstuen','比格達','霍姆科倫'],
  'Helsinki':     ['設計區','卡利奧','托洛','芬蘭堡','坎皮','烏拉斯卡里'],
  'Zurich':       ['舊城','湖濱','蘇黎世西區','Kreis 4','Kreis 5','班霍夫大街'],
  'Brussels':     ['大廣場','伊克塞爾','聖吉勒斯','摩倫貝克','沙博隆'],
  'Dublin':       ['坦普爾巴','多尼布魯克','達基','鳳凰公園','波特蘭','克隆夕夫'],
  'Reykjavik':    ['101區','藍湖','辛格韋德利','黑沙灘','傑古沙龍','雷克雅內斯半島'],
  'Dubrovnik':    ['舊城區','普洛切','拉帕德','斯捷潘','科卡拉'],
  'Naples':       ['舊城區','龐貝古城','蛋堡','卡波迪蒙特','托萊多街','基亞亞'],
  'Turin':        ['王宮','波河公園','穆勒門','格蘭馬達馬廣場','朱塞佩威爾第劇院'],
  'Bologna':      ['馬焦雷廣場','波隆那大學區','聖斯特凡諾教堂'],
  'Amalfi':       ['波西塔諾','拉維洛','大教堂廣場','艾米利亞諾洞穴'],
  'Dresden':      ['茨溫格宮','聖母教堂','德勒斯登王宮','新城區'],
  'Heidelberg':   ['海德堡城堡','老橋','大學廣場'],
  'Granada':      ['阿爾罕布拉宮','阿爾拜辛區','大教堂','薩克羅蒙特'],
  'Valencia':     ['藝術科學城','中央市場','絲綢交易所','土耳其塔','海灘區'],
  'Seville':      ['西班牙廣場','大教堂','聖十字區','瑪莉亞路易莎公園','特里亞納區'],
  'Bath':         ['皇家新月樓','普爾特尼橋','巴斯修道院','圓形廣場'],
  'Split':        ['戴克里先宮'],
  'Zagreb':       ['耶拉契奇廣場','多拉茨市場','聖史蒂芬大教堂','馬克西米爾公園'],
  // Eastern Europe
  'Warsaw':       ['老城廣場','皇家大道','維拉諾夫宮','普拉加','新世界街','瓦津基公園'],
  'Krakow':       ['舊城廣場','瓦維爾城堡','卡齊米日','弗洛里安斯卡街','扎科帕內','奧斯威辛'],
  'Tallinn':      ['舊城','上城','卡德里奧','皮里塔','泰勒梅'],
  'Riga':         ['老城','中央市場','阿爾伯特街','麥澤帕克','尤爾馬拉','聖彼得教堂'],
  'Vilnius':      ['老城','格迪米納斯塔','烏日皮斯','新城','特拉凱','大教堂廣場'],
  'Bucharest':    ['舊城區','勝利大道','赫勒斯特勞','文化宮','弗洛雷亞斯卡'],
  // Americas
  'New York':     ['曼哈頓','布魯克林','皇后區','中央公園','時代廣場','SOHO','格林威治村','哈林區','威廉斯堡','史泰登島'],
  'Los Angeles':  ['好萊塢','聖塔莫尼卡','威尼斯海灘','比弗利山','西好萊塢','韓國城','唐人街','馬里布','阿凱迪亞','聖塔莫尼卡山脈','格倫代爾','帕薩迪納','蒙特利公園','阿罕布拉'],
  'San Francisco':['漁人碼頭','唐人街','使命區','卡斯楚','海特-艾許伯里','海灣區','金門橋','諾布山'],
  'Las Vegas':    ['拉斯維加斯大道','弗里蒙特街','城市中心','薩默林','亨德森','北拉斯維加斯'],
  'Miami':        ['南海灘','溫伍德','設計區','科科納特格羅夫','布里克爾','灣港島','科勒爾蓋布爾斯'],
  'Chicago':      ['密歇根大道','河北','金融區','魏克爾公園','林肯廣場','芝加哥環路','海德公園'],
  'Hawaii':       ['威基基','大鑽石頭','珍珠港','歐胡島','茂宜島','大島','可愛島','拉奈島'],
  'Vancouver':    ['溫哥華市中心','格蘭維爾島','蓋士鎮','斯坦利公園','商業大道','奇拉諾','素里'],
  'Toronto':      ['CN塔','肯星頓市場','皇后街西','唐人街','蒸餾廠區','金融區','約克維爾'],
  'Cancun':       ['酒店區','市中心','普拉亞德爾卡門','圖盧姆','科蘇梅爾','伊斯拉穆赫雷斯'],
  'Mexico City':  ['查普爾特佩克','索卡洛','波朗科','羅馬區','科約阿坎','聖天使','特拉特洛爾科'],
  'Rio de Janeiro':['科帕卡巴納','伊帕內瑪','聖特雷莎','博塔福戈','拉帕','中心區','巴哈'],
  'Buenos Aires': ['巴勒莫','聖特爾莫','科里恩特斯大道','波卡','雷科萊塔','卡米尼托'],
  'Lima':         ['米拉弗洛雷斯','巴蘭科','聖伊西德羅','老城區','馬格達萊納','蘇爾科'],
  'Santiago':     ['貝拉維斯塔','普羅維登西亞','聖地牙哥老城','拉斯孔德斯','努紐阿','波利奧'],
  'Bogota':       ['坎德拉里亞','查平納羅','波利瓦爾廣場','烏薩坎','北區','蒙塞拉特山'],
  'Cartagena':    ['老城區','博卡格蘭德','格茲馬尼','羅塞達爾','海灘'],
  'Cusco':        ['武器廣場','聖多明哥教堂','薩克塞瓦曼','聖布拉斯','烏魯班巴','馬丘比丘'],
  'Washington DC':['國家廣場','林肯紀念堂','國會山','喬治城','史密森尼博物館群','威廉斯堡'],
  'Seattle':      ['太空針塔','派克市場','西雅圖中心','國會山莊區','巴拉德'],
  'Boston':       ['自由之路','芬威球場','昆西市場','後灣區','哈佛廣場','昆西'],
  'New Orleans':  ['法國區','波本街','花園區','河濱步道','爵士樂博物館'],
  'Montreal':     ['舊蒙特婁','皇家山公園','聖凱瑟琳街','拉丁區','奧林匹克公園'],
  'Sao Paulo':    ['保利斯塔大道','解放區','莫倫比','伊比拉普耶拉公園','老城區'],
  'Uyuni':        ['烏尤尼鹽沼','火車墳場','因卡瓦西島','紅湖','綠湖'],
  // Oceania
  'Sydney':       ['岩石區','達令港','邦迪海灘','莫斯曼','薩里山','帕丁頓','諾斯悉尼','悉尼奧林匹克公園'],
  'Melbourne':    ['聯邦廣場','菲茨羅伊','聖基爾達','布倫瑞克','科林伍德','中央商業區','南亞拉'],
  'Gold Coast':   ['衝浪者天堂','寬闊海灘','庫蘭加塔','博覽地','聖靈群島','黃金海岸主題公園','斯普林布魯克'],
  'Brisbane':     ['南岸','故事橋','佛蒂谷','新農場','帕丁頓','布里斯班CBD','史丹利街市場','康尼爾山','桑尼班克','布里斯班機場','坦伯林山'],
  'Perth':        ['弗里曼特爾','珀斯CBD','諾斯布里奇','科特斯洛海灘','國王公園','蘇比亞科','科金納普'],
  'Adelaide':     ['阿德萊德CBD','漢恩多夫','芭羅莎谷','格倫埃爾格','北德萊頓','諾頓薩米特'],
  'Cairns':       ['凱恩斯CBD','大堡礁','棕櫚灣','庫蘭達','道格拉斯港','艾瑟頓高地'],
  'Auckland':     ['市中心','龐森比','帕內爾','德文波特','霍恩比','懷赫科島','北岸'],
  'Queenstown':   ['天空纜車','米爾福德峽灣','箭鎮','瓦納卡','皇后鎮灣','弗蘭克頓'],
  'Wellington':   ['古巴街','泰和碼頭','維多利亞山','蒂帕帕博物館','科里馬馬港','彼得敦'],
  'Christchurch': ['卡德博納廣場','埃文河','植物園','里卡頓市場','利特爾頓','薩姆納'],
  'Rotorua':      ['羅托魯阿湖','地熱公園','毛利文化村','彩虹溫泉','懷歐陶普地熱谷','地獄之門'],
  'Hobart':       ['薩拉曼卡市場','威靈頓山','巴特里角','莫納現代藝術博物館'],
  'Uluru':        ['烏魯魯巨石','尤拉拉小鎮'],
  // Africa
  'Cape Town':    ['桌山','博卡普','綠點','沃特坎特','坎普斯灣','西蒙斯敦','斯特倫博斯','羅本島'],
  'Marrakech':    ['麥地那','賈馬拉夫納廣場','蘇克','吉利茲','帕爾梅里亞','薩阿德陵墓'],
  'Cairo':        ['吉薩金字塔','汗哈利利市集','開羅博物館','伊斯蘭開羅','科普特開羅','扎馬萊克','納賽爾城'],
  'Nairobi':      ['奈洛比國家公園','長頸鹿中心','大衛謝爾德里克大象孤兒院','市中心','卡倫'],
  'Serengeti':    ['塞倫蓋提國家公園','恩戈羅恩戈羅保護區','塞羅內拉','格魯梅提'],
  // 2026-09-29 補上缺失城市
  'Matsuyama':    ['松山城','道後溫泉','大街道','石手寺','松山市站'],
  'Takamatsu':    ['栗林公園','高松港','屋島','丸龜町商店街','玉藻公園'],
  'Gangneung':    ['鏡浦台','安木海灘咖啡街','正東津','烏竹軒','江陵中央市場'],
  'Jeonju':       ['全州韓屋村','慶基殿','全州南部市場','德津公園','全州客舍'],
  'Sokcho':       ['雪嶽山','束草中央市場','束草海水浴場','永琴亭','阿爸村'],
  'Tongyeong':    ['東皮郎壁畫村','統營中央市場','閑山島','彌勒山'],
  'Yeosu':        ['梧桐島','麗水海上纜車','向日庵','李舜臣廣場','萬聖里黑沙海灘'],
  'Ayutthaya':    ['大城歷史公園','瑪哈泰寺','柴瓦塔那蘭寺','邦芭茵夏宮','大城水上市場'],
  'Hua Hin':      ['華欣夜市','華欣火車站','愛與希望之宮','猴子山','蟬夜市'],
  'Koh Samui':    ['查汶海灘','拉邁海灘','大佛寺','波普漁人村','湄南海灘'],
  'Ha Long Bay':  ['拜寨','巡州島','下龍市場'],
  'Hoi An':       ['會安古城','日本橋','安邦海灘','會安夜市','椰林竹籃船'],
  'Hue':          ['順化皇城','天姥寺','啟定皇陵','東巴市場','香江'],
  'Lombok':       ['聖吉吉','吉利群島','龍目庫塔','林查尼火山','馬塔蘭'],
  'Ubud':         ['烏布皇宮','聖猴森林公園','德格拉朗梯田','烏布藝術市場','坎普罕山脊步道'],
  'Langkawi':     ['天空之橋','珍南海灘','瓜鎮','老鷹廣場','紅樹林地質公園'],
  'Lijiang':      ['麗江古城','束河古鎮','玉龍雪山','黑龍潭','白沙古鎮'],
  'Milford Sound': ['米佛峽灣碼頭','蒂阿瑙','鏡湖'],
  'Annecy':       ['安錫老城','安錫湖','島宮','安錫城堡','愛之橋'],
  'Bordeaux':     ['交易所廣場','葡萄酒城','聖安德烈大教堂','聖凱瑟琳街','夏爾特龍區'],
  'Cannes':       ['影節宮','克魯瓦塞特大道','蘇給老城','福維爾市場','聖瑪格麗特島'],
  'Lyon':         ['里昂老城','富維耶聖母院','白萊果廣場','紅十字山','金頭公園','匯流博物館'],
  'Nice':         ['英國人散步大道','尼斯老城','城堡山','馬塞納廣場','西米耶','尼斯港'],
  'Strasbourg':   ['小法國','斯特拉斯堡大教堂','克萊貝爾廣場','歐洲議會','橘園公園'],
  'Cinque Terre': ['蒙特羅索','韋爾納札','科爾尼利亞','馬納羅拉','里奧馬焦雷'],
  'Sicily':       ['巴勒莫','陶爾米納','卡塔尼亞','錫拉庫薩','神殿谷','切法盧'],
  'Cologne':      ['科隆大教堂','科隆老城','霍亨索倫橋','巧克力博物館','比利時區','萊茵公園'],
  'Hamburg':      ['易北愛樂廳','倉庫城','聖保利','內阿爾斯特湖','漢堡市政廳','港口新城'],
  'Stuttgart':    ['施洛斯廣場','賓士博物館','保時捷博物館','威廉瑪動植物園','國王大街','斯圖加特中央車站'],
  'Bergen':       ['布呂根','魚市場','弗洛伊恩山','烏爾里肯山','哈康宮','卑爾根水族館'],
  'Lugano':       ['盧加諾湖畔','改革廣場','聖薩爾瓦多山','布雷山','甘德里亞','莫爾科特'],
  'Maastricht':   ['維克廣場','市場廣場','聖瑟法斯橋','多明我會書店教堂','聖彼得要塞','維克區'],
  'Frankfurt':    ['羅馬廣場','博物館河岸','薩克森豪森','采爾大街','美因塔','棕櫚園'],
  'Oxford':       ['基督堂學院','博德利圖書館','耶利哥區'],
  'Patagonia':    ['百內國家公園','納塔萊斯港','蓬塔阿雷納斯'],
  'Zanzibar':     ['石頭城','努威海灘','帕傑海灘','約札尼森林','監獄島'],
  'Jerusalem':    ['耶路撒冷舊城','西牆','聖墓教堂','橄欖山','馬哈尼耶胡達市場','以色列博物館'],
};

// Aliases for Chinese city names
CITY_DISTRICTS['香港']    = CITY_DISTRICTS['Hong Kong'];
CITY_DISTRICTS['澳門']    = CITY_DISTRICTS['Macau'];
CITY_DISTRICTS['台北']    = CITY_DISTRICTS['Taipei'];
CITY_DISTRICTS['高雄']    = CITY_DISTRICTS['Kaohsiung'];
CITY_DISTRICTS['台中']    = CITY_DISTRICTS['Taichung'];
CITY_DISTRICTS['台南']    = CITY_DISTRICTS['Tainan'];
CITY_DISTRICTS['宜蘭']    = CITY_DISTRICTS['Yilan'];
CITY_DISTRICTS['花蓮']    = CITY_DISTRICTS['Hualien'];
CITY_DISTRICTS['墾丁']    = CITY_DISTRICTS['Kenting'];
CITY_DISTRICTS['九份']    = CITY_DISTRICTS['Jiufen'];
CITY_DISTRICTS['北京']    = CITY_DISTRICTS['Beijing'];
CITY_DISTRICTS['上海']    = CITY_DISTRICTS['Shanghai'];
CITY_DISTRICTS['廣州']    = CITY_DISTRICTS['Guangzhou'];
CITY_DISTRICTS['深圳']    = CITY_DISTRICTS['Shenzhen'];
CITY_DISTRICTS['成都']    = CITY_DISTRICTS['Chengdu'];
CITY_DISTRICTS['重慶']    = CITY_DISTRICTS['Chongqing'];
CITY_DISTRICTS['西安']    = CITY_DISTRICTS["Xi'an"];
CITY_DISTRICTS['杭州']    = CITY_DISTRICTS['Hangzhou'];
CITY_DISTRICTS['廈門']    = CITY_DISTRICTS['Xiamen'];
CITY_DISTRICTS['桂林']    = CITY_DISTRICTS['Guilin'];
CITY_DISTRICTS['三亞']    = CITY_DISTRICTS['Sanya'];
CITY_DISTRICTS['張家界']  = CITY_DISTRICTS['Zhangjiajie'];
CITY_DISTRICTS['昆明']    = CITY_DISTRICTS['Kunming'];
CITY_DISTRICTS['青島']    = CITY_DISTRICTS['Qingdao'];
CITY_DISTRICTS['東京']    = CITY_DISTRICTS['Tokyo'];
CITY_DISTRICTS['大阪']    = CITY_DISTRICTS['Osaka'];
CITY_DISTRICTS['京都']    = CITY_DISTRICTS['Kyoto'];
CITY_DISTRICTS['福岡']    = CITY_DISTRICTS['Fukuoka'];
CITY_DISTRICTS['札幌']    = CITY_DISTRICTS['Sapporo'];
CITY_DISTRICTS['名古屋']  = CITY_DISTRICTS['Nagoya'];
CITY_DISTRICTS['沖繩']    = CITY_DISTRICTS['Okinawa'];
CITY_DISTRICTS['廣島']    = CITY_DISTRICTS['Hiroshima'];
CITY_DISTRICTS['奈良']    = CITY_DISTRICTS['Nara'];
CITY_DISTRICTS['神戶']    = CITY_DISTRICTS['Kobe'];
CITY_DISTRICTS['首爾']    = CITY_DISTRICTS['Seoul'];
CITY_DISTRICTS['釜山']    = CITY_DISTRICTS['Busan'];
CITY_DISTRICTS['濟州']    = CITY_DISTRICTS['Jeju'];
CITY_DISTRICTS['新加坡']  = CITY_DISTRICTS['Singapore'];
CITY_DISTRICTS['曼谷']    = CITY_DISTRICTS['Bangkok'];
CITY_DISTRICTS['清邁']    = CITY_DISTRICTS['Chiang Mai'];
CITY_DISTRICTS['普吉島']  = CITY_DISTRICTS['Phuket'];
CITY_DISTRICTS['峇里島']  = CITY_DISTRICTS['Bali'];
CITY_DISTRICTS['雅加達']  = CITY_DISTRICTS['Jakarta'];
CITY_DISTRICTS['日惹']    = CITY_DISTRICTS['Yogyakarta'];
CITY_DISTRICTS['吉隆坡']  = CITY_DISTRICTS['Kuala Lumpur'];
CITY_DISTRICTS['檳城']    = CITY_DISTRICTS['Penang'];
CITY_DISTRICTS['河內']    = CITY_DISTRICTS['Hanoi'];
CITY_DISTRICTS['胡志明市'] = CITY_DISTRICTS['Ho Chi Minh City'];
CITY_DISTRICTS['峴港']    = CITY_DISTRICTS['Da Nang'];
CITY_DISTRICTS['馬尼拉']  = CITY_DISTRICTS['Manila'];
CITY_DISTRICTS['宿霧']    = CITY_DISTRICTS['Cebu'];
CITY_DISTRICTS['暹粒']    = CITY_DISTRICTS['Siem Reap'];
CITY_DISTRICTS['科倫坡']  = CITY_DISTRICTS['Colombo'];
CITY_DISTRICTS['馬爾地夫'] = CITY_DISTRICTS['Maldives'];
CITY_DISTRICTS['孟買']    = CITY_DISTRICTS['Mumbai'];
CITY_DISTRICTS['新德里']  = CITY_DISTRICTS['Delhi'];
CITY_DISTRICTS['果阿']    = CITY_DISTRICTS['Goa'];
CITY_DISTRICTS['加德滿都'] = CITY_DISTRICTS['Kathmandu'];
CITY_DISTRICTS['杜拜']    = CITY_DISTRICTS['Dubai'];
CITY_DISTRICTS['阿布達比'] = CITY_DISTRICTS['Abu Dhabi'];
CITY_DISTRICTS['多哈']    = CITY_DISTRICTS['Doha'];
CITY_DISTRICTS['伊斯坦堡'] = CITY_DISTRICTS['Istanbul'];
CITY_DISTRICTS['巴黎']    = CITY_DISTRICTS['Paris'];
CITY_DISTRICTS['倫敦']    = CITY_DISTRICTS['London'];
CITY_DISTRICTS['羅馬']    = CITY_DISTRICTS['Rome'];
CITY_DISTRICTS['米蘭']    = CITY_DISTRICTS['Milan'];
CITY_DISTRICTS['佛羅倫斯'] = CITY_DISTRICTS['Florence'];
CITY_DISTRICTS['威尼斯']  = CITY_DISTRICTS['Venice'];
CITY_DISTRICTS['巴塞隆納'] = CITY_DISTRICTS['Barcelona'];
CITY_DISTRICTS['馬德里']  = CITY_DISTRICTS['Madrid'];
CITY_DISTRICTS['阿姆斯特丹'] = CITY_DISTRICTS['Amsterdam'];
CITY_DISTRICTS['柏林']    = CITY_DISTRICTS['Berlin'];
CITY_DISTRICTS['慕尼黑']  = CITY_DISTRICTS['Munich'];
CITY_DISTRICTS['布拉格']  = CITY_DISTRICTS['Prague'];
CITY_DISTRICTS['維也納']  = CITY_DISTRICTS['Vienna'];
CITY_DISTRICTS['布達佩斯'] = CITY_DISTRICTS['Budapest'];
CITY_DISTRICTS['里斯本']  = CITY_DISTRICTS['Lisbon'];
CITY_DISTRICTS['雅典']    = CITY_DISTRICTS['Athens'];
CITY_DISTRICTS['聖托里尼'] = CITY_DISTRICTS['Santorini'];
CITY_DISTRICTS['愛丁堡']  = CITY_DISTRICTS['Edinburgh'];
CITY_DISTRICTS['哥本哈根'] = CITY_DISTRICTS['Copenhagen'];
CITY_DISTRICTS['斯德哥爾摩'] = CITY_DISTRICTS['Stockholm'];
CITY_DISTRICTS['奧斯陸']  = CITY_DISTRICTS['Oslo'];
CITY_DISTRICTS['赫爾辛基'] = CITY_DISTRICTS['Helsinki'];
CITY_DISTRICTS['蘇黎世']  = CITY_DISTRICTS['Zurich'];
CITY_DISTRICTS['布魯塞爾'] = CITY_DISTRICTS['Brussels'];
CITY_DISTRICTS['都柏林']  = CITY_DISTRICTS['Dublin'];
CITY_DISTRICTS['雷克雅未克'] = CITY_DISTRICTS['Reykjavik'];
CITY_DISTRICTS['杜布羅夫尼克'] = CITY_DISTRICTS['Dubrovnik'];
CITY_DISTRICTS['華沙']    = CITY_DISTRICTS['Warsaw'];
CITY_DISTRICTS['克拉科夫'] = CITY_DISTRICTS['Krakow'];
CITY_DISTRICTS['塔林']    = CITY_DISTRICTS['Tallinn'];
CITY_DISTRICTS['里加']    = CITY_DISTRICTS['Riga'];
CITY_DISTRICTS['維爾紐斯'] = CITY_DISTRICTS['Vilnius'];
CITY_DISTRICTS['布加勒斯特'] = CITY_DISTRICTS['Bucharest'];
CITY_DISTRICTS['紐約']    = CITY_DISTRICTS['New York'];
CITY_DISTRICTS['洛杉磯']  = CITY_DISTRICTS['Los Angeles'];
CITY_DISTRICTS['舊金山']  = CITY_DISTRICTS['San Francisco'];
CITY_DISTRICTS['拉斯維加斯'] = CITY_DISTRICTS['Las Vegas'];
CITY_DISTRICTS['邁阿密']  = CITY_DISTRICTS['Miami'];
CITY_DISTRICTS['芝加哥']  = CITY_DISTRICTS['Chicago'];
CITY_DISTRICTS['夏威夷']  = CITY_DISTRICTS['Hawaii'];
CITY_DISTRICTS['溫哥華']  = CITY_DISTRICTS['Vancouver'];
CITY_DISTRICTS['多倫多']  = CITY_DISTRICTS['Toronto'];
CITY_DISTRICTS['坎昆']    = CITY_DISTRICTS['Cancun'];
CITY_DISTRICTS['墨西哥城'] = CITY_DISTRICTS['Mexico City'];
CITY_DISTRICTS['里約熱內盧'] = CITY_DISTRICTS['Rio de Janeiro'];
CITY_DISTRICTS['布宜諾斯艾利斯'] = CITY_DISTRICTS['Buenos Aires'];
CITY_DISTRICTS['利馬']    = CITY_DISTRICTS['Lima'];
CITY_DISTRICTS['聖地牙哥'] = CITY_DISTRICTS['Santiago'];
CITY_DISTRICTS['波哥大']  = CITY_DISTRICTS['Bogota'];
CITY_DISTRICTS['卡塔赫納'] = CITY_DISTRICTS['Cartagena'];
CITY_DISTRICTS['庫斯科']  = CITY_DISTRICTS['Cusco'];
CITY_DISTRICTS['悉尼']    = CITY_DISTRICTS['Sydney'];
CITY_DISTRICTS['墨爾本']  = CITY_DISTRICTS['Melbourne'];
CITY_DISTRICTS['黃金海岸'] = CITY_DISTRICTS['Gold Coast'];
CITY_DISTRICTS['布里斯班'] = CITY_DISTRICTS['Brisbane'];
CITY_DISTRICTS['珀斯']    = CITY_DISTRICTS['Perth'];
CITY_DISTRICTS['阿德萊德'] = CITY_DISTRICTS['Adelaide'];
CITY_DISTRICTS['凱恩斯']  = CITY_DISTRICTS['Cairns'];
CITY_DISTRICTS['奧克蘭']  = CITY_DISTRICTS['Auckland'];
CITY_DISTRICTS['皇后鎮']  = CITY_DISTRICTS['Queenstown'];
CITY_DISTRICTS['威靈頓']  = CITY_DISTRICTS['Wellington'];
CITY_DISTRICTS['基督城']  = CITY_DISTRICTS['Christchurch'];
CITY_DISTRICTS['羅托魯阿'] = CITY_DISTRICTS['Rotorua'];
CITY_DISTRICTS['開普敦']  = CITY_DISTRICTS['Cape Town'];
CITY_DISTRICTS['馬拉喀什'] = CITY_DISTRICTS['Marrakech'];
CITY_DISTRICTS['開羅']    = CITY_DISTRICTS['Cairo'];
CITY_DISTRICTS['松山'] = CITY_DISTRICTS['Matsuyama'];
CITY_DISTRICTS['高松'] = CITY_DISTRICTS['Takamatsu'];
CITY_DISTRICTS['江陵'] = CITY_DISTRICTS['Gangneung'];
CITY_DISTRICTS['全州'] = CITY_DISTRICTS['Jeonju'];
CITY_DISTRICTS['束草'] = CITY_DISTRICTS['Sokcho'];
CITY_DISTRICTS['統營'] = CITY_DISTRICTS['Tongyeong'];
CITY_DISTRICTS['麗水'] = CITY_DISTRICTS['Yeosu'];
CITY_DISTRICTS['大城'] = CITY_DISTRICTS['Ayutthaya'];
CITY_DISTRICTS['華欣'] = CITY_DISTRICTS['Hua Hin'];
CITY_DISTRICTS['蘇梅島'] = CITY_DISTRICTS['Koh Samui'];
CITY_DISTRICTS['下龍灣'] = CITY_DISTRICTS['Ha Long Bay'];
CITY_DISTRICTS['會安'] = CITY_DISTRICTS['Hoi An'];
CITY_DISTRICTS['順化'] = CITY_DISTRICTS['Hue'];
CITY_DISTRICTS['龍目島'] = CITY_DISTRICTS['Lombok'];
CITY_DISTRICTS['烏布'] = CITY_DISTRICTS['Ubud'];
CITY_DISTRICTS['蘭卡威'] = CITY_DISTRICTS['Langkawi'];
CITY_DISTRICTS['麗江'] = CITY_DISTRICTS['Lijiang'];
CITY_DISTRICTS['米佛峽灣'] = CITY_DISTRICTS['Milford Sound'];
CITY_DISTRICTS['安錫'] = CITY_DISTRICTS['Annecy'];
CITY_DISTRICTS['波爾多'] = CITY_DISTRICTS['Bordeaux'];
CITY_DISTRICTS['坎城'] = CITY_DISTRICTS['Cannes'];
CITY_DISTRICTS['里昂'] = CITY_DISTRICTS['Lyon'];
CITY_DISTRICTS['尼斯'] = CITY_DISTRICTS['Nice'];
CITY_DISTRICTS['斯特拉斯堡'] = CITY_DISTRICTS['Strasbourg'];
CITY_DISTRICTS['五漁村'] = CITY_DISTRICTS['Cinque Terre'];
CITY_DISTRICTS['西西里島'] = CITY_DISTRICTS['Sicily'];
CITY_DISTRICTS['科隆'] = CITY_DISTRICTS['Cologne'];
CITY_DISTRICTS['漢堡'] = CITY_DISTRICTS['Hamburg'];
CITY_DISTRICTS['法蘭克福'] = CITY_DISTRICTS['Frankfurt'];
CITY_DISTRICTS['牛津'] = CITY_DISTRICTS['Oxford'];
CITY_DISTRICTS['巴塔哥尼亞'] = CITY_DISTRICTS['Patagonia'];
CITY_DISTRICTS['桑吉巴爾'] = CITY_DISTRICTS['Zanzibar'];
CITY_DISTRICTS['耶路撒冷'] = CITY_DISTRICTS['Jerusalem'];

export function getDistricts(cityKey) {
  if (!cityKey) return [];
  return CITY_DISTRICTS[cityKey] || [];
}

// Some district chips shown in the filter UI are a display-level grouping of
// several finer-grained values that actually appear in managed_attractions.district
// (e.g. Hong Kong's "中西區" chip covers rows individually tagged 中環/上環/西營盤,
// kept fine-grained in the DB for accuracy). Filtering must match against every
// member, not just the chip's own label, or grouped rows silently disappear.
const DISTRICT_GROUPS = {
  'Hong Kong': {
    '中西區': ['中西區', '中環', '上環', '西營盤'],
    // 馬鞍山 has no attractions tagged with it directly in the DB (all such
    // rows use the official district name 沙田) — this alias exists only so
    // GPS reverse-geocoding, which reports the finer neighbourhood name
    // Nominatim returns (e.g. standing in Ma On Shan), can still match the
    // 沙田 filter chip. See EC_Travel_v2.jsx's geo-district-match effect.
    '沙田': ['沙田', '馬鞍山'],
  },
};

// Raw district values (as stored on an attraction) that a given chip should
// match. cityKey is optional — chip labels are city-specific strings, so when
// the caller doesn't have a normalized cityKey handy (e.g. it only has the
// display name, not the CITY_DISTRICTS key), every city's groups are checked.
export function districtMembers(chip, cityKey) {
  if (!chip) return [];
  if (cityKey && DISTRICT_GROUPS[cityKey]?.[chip]) return DISTRICT_GROUPS[cityKey][chip];
  for (const groups of Object.values(DISTRICT_GROUPS)) {
    if (groups[chip]) return groups[chip];
  }
  return [chip];
}

// Whether an attraction's raw `district` value belongs under the given chip.
export function matchesDistrict(attractionDistrict, chip, cityKey) {
  if (!attractionDistrict || !chip) return false;
  return districtMembers(chip, cityKey).includes(attractionDistrict);
}

// The chips worth offering: those with at least one row to show. A chip listed
// for a city but with no attractions would only lead to an empty page.
export function availableDistricts(chips, rows, cityKey) {
  const present = new Set(rows.map((r) => r.district).filter(Boolean));
  return chips.filter((chip) => districtMembers(chip, cityKey).some((m) => present.has(m)));
}

// Which district to select once a city or its options change. Before the city's
// rows arrive, a chip of this city (e.g. the GPS match) is kept, so it can apply
// once they load; a district left over from another city is cleared.
export function resolveDistrict(current, chips, available, hasRows) {
  if (!hasRows) return chips.includes(current) ? current : '';
  if (available.includes(current)) return current;
  return available[0] || '';
}

// Reverse lookup: given a district/neighbourhood name, find which city it
// belongs to. Used to catch geolocation providers (e.g. Nominatim) that
// return a sub-city area as the "city" field — without this, that area gets
// mistaken for the whole city itself.
export function findCityByDistrict(districtName) {
  if (!districtName) return null;
  let fallback = null;
  for (const [cityKey, districts] of Object.entries(CITY_DISTRICTS)) {
    const allNames = districts.flatMap(d => districtMembers(d, cityKey));
    if (allNames.includes(districtName)) {
      if (/[一-鿿]/.test(cityKey)) return cityKey; // prefer the Chinese alias
      if (!fallback) fallback = cityKey;
    }
  }
  return fallback;
}
